// ─────────────────────────────────────────
//  SHARED STATE
// ─────────────────────────────────────────

export const SUPABASE_URL = 'https://rnjgmaxvkseebujyhenz.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJuamdtYXh2a3NlZWJ1anloZW56Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczNjkyMjEsImV4cCI6MjA5Mjk0NTIyMX0.wVyv8x8uiUisEMBuGjtIYWheClod85HxsKckma-U_Es';

// Global Supabase client (initialized from UMD global)
export const sb = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export const S = {
  view:     'chat',
  mode:     'html',
  code:     '',
  history:  [],
  memory:   '',
  busy:     false,
  name:     '',
  key:      '',
  builds:   0,
  MAX_FREE: 30,
  session:  null,
  user:     null,
  tier:     'free',
  isAdmin:  false,
  convId:   null,
  projectId: null,
  localProjectId: null,
};

// ── localStorage helpers ──
export function ls(k) { try { return localStorage.getItem(k); } catch(_) { return null; } }
export function setLs(k, v) { try { localStorage.setItem(k, v); } catch(_) {} }
export function rmLs(k) { try { localStorage.removeItem(k); } catch(_) {} }
